export default __webpack_public_path__ + "static/media/LowSignalStrength.7276917c.svg";